import { useFormik } from "formik";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../../../components/buttons/button";
import { TextLink } from "../../../components/buttons/textLink";
import { TextInput } from "../../../components/inputs/textInput";
import { OtpCountdownTImer } from "../../../components/timer/OtpCountdownTimer";
import { HeaderSubheader } from "../../../components/typography/headerSubheader";
import {
  useForgotPasswordChangeMutation,
  useForgotPasswordMutation,
} from "../../../redux/features/auth/auth.api";
import { createNewPasswordSchema } from "../../../validationSchema";

export const ForgotPasswordCreate = ({
  setStep,
}: {
  setStep: (step: number) => void;
}) => {
  const [forgotPassword] = useForgotPasswordMutation();

  const [changePassword, { isLoading: changingPassword }] =
    useForgotPasswordChangeMutation();

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const {
    values,
    errors,
    isValid,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useFormik({
    initialValues: {
      code: "",
      password: "",
      newPassword: "",
    },
    validationSchema: createNewPasswordSchema,
    onSubmit: async (data) => {
      const resp = await changePassword({
        Email: searchParams.get("email") ?? "",
        Code: data.code,
        Password: data.password,
      });

      if (resp.data?.success) {
        navigate("/auth/sign-in");
      }
    },
  });

  return (
    <div className="w-full">
      <HeaderSubheader
        header={
          searchParams.get("step") === "activateAccount"
            ? "Hey there 👋🏾, let's set up your password"
            : "Create New Password"
        }
        subheader={
          searchParams.get("step") === "activateAccount" ? (
            <div>Kindly ensure you keep your password safe.</div>
          ) : (
            <p>
              <span className="break-all">
                You requested a password reset for{" "}
                <span className="text-pry-dark-green-300/80 font-medium">
                  {searchParams.get("email")}.
                </span>
              </span>{" "}
              If an account with this email exists, a password reset code will
              be sent to it.
            </p>
          )
        }
      />

      <form className="mt-6 flex flex-col gap-3" onSubmit={handleSubmit}>
        <TextInput
          type="text"
          name={"code"}
          value={values.code}
          placeholder="Code"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.code && touched.code ? errors.code : ""}
          hasIcon={false}
          autoComplete="off"
        />

        <TextInput
          type="password"
          name={"password"}
          value={values.password}
          placeholder="New password"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.password && touched.password ? errors.password : ""}
          hasIcon={false}
          autoComplete="off"
        />

        <TextInput
          type="password"
          name={"newPassword"}
          value={values.newPassword}
          placeholder="Confirm password"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={
            errors.newPassword && touched.newPassword ? errors.newPassword : ""
          }
          hasIcon={false}
          autoComplete="off"
        />

        <div className="w-full text-right !text-xs text-grey-200">
          Didn’t get any code?{" "}
          <OtpCountdownTImer
            text="Resend Code"
            onClick={async () => {
              await forgotPassword({ Email: searchParams.get("email") ?? "" });
            }}
          />
        </div>

        <div className="w-full text-right mt-5 md:mt-3">
          <Button
            text="Create New Password"
            type="submit"
            disabled={!isValid || changingPassword}
            loading={changingPassword}
          />
        </div>

        <div className="w-full mt-1 !text-sm text-grey-400">
          I remember my password.{" "}
          <TextLink
            to="/auth/sign-in"
            text="Login"
            className=""
            onClick={() => {}}
          />
        </div>
      </form>
    </div>
  );
};
